import { Client } from '@/utilities/api/Client';
import { MetricsEndpoint } from '@api/endpoints';

/** Internal-only. */
export class MetricsApi {
  static getPointsMetrics (
    body: MetricsEndpoint.GetPointsMetrics.Request,
  ): Promise<MetricsEndpoint.GetPointsMetrics.Response> {
    return Client('admin/metrics/points', { body, method: 'POST' });
  }
}
